// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"69b1e6d4","335":"e5ced4a9","470":"6b8d2b01"}[chunkId] + ".chunk.js";
};